import { ChangeEvent, FC } from 'react'

import { Input } from '@ui/components/Input/Input'
import { CloseIcon } from '@ui/icons/Close.icon'
import { SearchIcon } from '@ui/icons/Search.icon'

export interface PopoverSearchInputProps {
  value?: string
  label?: string
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  onSearch?: () => void
  onClear?: () => void
  size?: 'xl' | 'lg'
}

export const PopoverSearchInput: FC<PopoverSearchInputProps> = (props) => {
  const { value, label, onChange, onSearch, onClear, size } = props

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange?.(event)
  }

  const handleButtonClick = () => {
    if (value?.length) {
      onClear?.()
    } else {
      onSearch?.()
    }
  }

  return (
    <Input
      type='text'
      label=''
      placeholder={label}
      value={value}
      onChange={handleChange}
      autoFocus
      variant='search'
      size={size || 'lg'}
      leftIcon={SearchIcon}
      rightIcon={value?.length ? CloseIcon : undefined}
      onEndIconClick={handleButtonClick}
    />
  )
}
